module.exports = __webpack_public_path__ + "1c6a98dfe19caf42a4f3c14e63d15390.pdf";